export default "__VITE_ASSET__8KI6SLHU__"